import { useState } from 'react';

import { useAttachmentSignedUrl } from 'hooks/useAttachmentSignedUrl';

/**
 * Fetches a signed view-only URL for an attachment without opening a window.
 * Use to embed the attachment as an iframe (e.g., a citation hover preview).
 *
 * Returns `{ url, fetch }`. `url` is null until `fetch()` has been called and
 * the request has resolved.
 */
export function useAttachmentUrl(attachmentId: string, attachableModel?: string) {
  const [shouldFetch, setShouldFetch] = useState(false);

  const { data } = useAttachmentSignedUrl(attachmentId, attachableModel, { enabled: shouldFetch });

  return {
    url: data?.url ?? null,
    fetch: () => setShouldFetch(true),
  };
}
